import React, { useState, useEffect } from 'react';
import { Grid, Paper, Button, TextField, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { createStyles, makeStyles, Theme, withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { getBookingOverview } from "../../actions/GenomicsResearchAction";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// import "./dashboard.css";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            height: "100%",
            padding: "20px",
        },
        cardContent: {
            textAlign: "center",
        },
        center: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        text: { color: "black" },
    })
);
const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);


interface Props {
    getBookingOverview: any;
    bookingoverview: any;
    userDetails: any;
    loading: any
}

const Dashboard: React.FC<Props> = ({
    getBookingOverview,
    bookingoverview,
    loading,
}) => {
    const classes = useStyles();
    const [docEmail, setDocEmail] = useState<any>([]);
    const [dataType, setDataType] = useState<any>();
    const [pass, setPass] = useState<any>();
    return (
        <div style={{ width: "100%", margin: "60px auto" }}>
            <div style={{ backgroundColor: "#0b2857", border: "2px solid #0b2857", borderRadius: "10px" }}>
                <h2 style={{ textAlign: "center", color: "white" }}>Data To Share</h2>
            </div>
            {/* <div style={{ margin: "10px 0px 0px 0px" }} id="geno">
                <div className="cardsAppointment" style={{ display: 'flex', flexDirection: 'row', alignItems: "flex-start" }}>
                    <div>
                        <Grid container>
                            <Grid item sm={12}>
                                <h5 style={{ color: "#ffffff", fontWeight: 'bold' }}>Sample QC
                                </h5>
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <Grid container>
                            <Grid item sm={12}>
                                <h5 style={{ color: "#ffffff", fontWeight: 'bold' }}>Data QC</h5>
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <Grid container>
                            <Grid item sm={12}>
                                <h5 style={{ color: "#ffffff", fontWeight: 'bold' }}>Final Report</h5>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div> */}
            <Paper style={{marginTop:"20px"}}>
                <Grid container spacing={2} style={{ marginLeft: 1 }}>
                    <Grid item xs={12} sm={3}>
                        <FormControl style={{ width: "100%" }} className="input">
                            <InputLabel>Data Type</InputLabel>
                            <Select
                                label="Billing Completed"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={dataType || "none"}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setDataType(e.target.value)}
                            >
                                <MenuItem value="none" disabled>Select Data Type</MenuItem>
                                <MenuItem value="Raw Data">Raw data</MenuItem>
                                <MenuItem value="Vcf File">Vcf File</MenuItem>
                                <MenuItem value="Vcf File">Sample QC</MenuItem>
                                <MenuItem value="Vcf File">Data Qc</MenuItem>
                                <MenuItem value="Vcf File">Final Report</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="Email ID"
                            variant="outlined"
                            className="input"
                            placeholder="Enter Email ID"
                            fullWidth
                            value={docEmail}
                            required
                            onChange={(e) => setDocEmail(e.target.value.replace(/\s/g, ''))}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="Password"
                            variant="outlined"
                            className="input"
                            placeholder="Enter Password"
                            fullWidth
                            value={pass}
                            required
                            onChange={(e) => setPass(e.target.value.replace(/\s/g, ''))}
                        />
                    </Grid>
                    <Grid xs={12} sm={3} >
                        <Button
                            color="primary"
                            variant="contained"
                            type="submit"
                            style={{ width: 300, marginTop: "9px" }}
                        >
                            Send
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </div >
    );
};

const mapStateToProps = (state: any) => ({
    bookingoverview: state.GenomicsCAReducer.bookingoverview,
    loading: state.GenomicsCAReducer.loading,
});

export default connect(mapStateToProps, {
    getBookingOverview,
})(Dashboard);